export enum FeaturedPortfolioTabsKeys {
  PROPERTIES = "PROPERTIES",
  PORTFOLIOS = "PORTFOLIOS",
}

export const DEFAULT_FEATURED_PORTFOLIO_TAB_KEY = FeaturedPortfolioTabsKeys.PROPERTIES;
